import React from 'react';
import { CleanButton } from 'ds/components/button';
import { makeCallAll } from 'components/filters/utils';
import { FilterButtonsContainer } from 'components/filters/styled/dropdown';
import { useLocale } from 'locale';

interface FiltersControlsProps {
  onClose: () => void;
  onClear: () => void;
  onSubmit: () => void;
}

export const FiltersControls: React.FC<FiltersControlsProps> = React.memo((props) => {
  const { onClose, onClear, onSubmit } = props;
  const { t } = useLocale();
  return (
    <FilterButtonsContainer>
      <CleanButton
        mode="secondary"
        data-auto="clear-button"
        onClick={makeCallAll(onClose, onClear)}
      >
        {t('developerPage.filters.clear')}
      </CleanButton>
      <CleanButton
        data-auto="submit-button"
        onClick={makeCallAll(onClose, onSubmit)}
      >
        {t('developerPage.filters.submit')}
      </CleanButton>
    </FilterButtonsContainer>
  );
});
